import {
  GVL,
  TCModel,
  TCString,
} from '@iabtechlabtcf/core'

import {
  CMP_ID,
  CMP_VERSION,
} from 'constants/cmp'

import { getTCString } from 'utils/tcfStore'

import { USES_SERVICE_SPECIFIC_SCOPE } from './constants'


export default function makeTCModel(globalVendorList) {
  // N.B.: instantiating this has the unfortunate side-effect of
  // creating window.__tcfapi. Or, perhaps more accurately, it
  // replaces the expected stub implementation of __tcfapi() with a
  // fully-functional implementation
  const gvl = new GVL(globalVendorList)

  const tcModel = new TCModel(gvl)
  tcModel.cmpId = CMP_ID
  tcModel.cmpVersion = CMP_VERSION
  tcModel.isServiceSpecific = USES_SERVICE_SPECIFIC_SCOPE

  const tcString = getTCString()

  if ( tcString ) {
    return TCString.decode(tcString, tcModel)
  }

  // Mark all vendors from the GVL as disclosed since they are being
  // presented to the user for the first time.
  if ( gvl.vendors ) {
    Object.keys(gvl.vendors)
      .forEach((vendorID) => {
        tcModel.vendorsDisclosed.set(Number(vendorID))
      })
  }

  return tcModel
}
